<div class="fc-meta-bar mt-3 mb-3">
  @if (isInstructionsEnabled) {
    <button class="fcInstructionsBtn" type="button" (click)="showInstructions()" title="View FileCapture Instructions">Instructions</button>
  }
  @if (referenceId) {
    <span class="fc-ref-display">Reference ID: <strong>{{ referenceId }}</strong></span>
  }
</div>
